import React, {useEffect,useState,useRef} from "react";
import "../../../Components/ProductRegal/ProductRegal.scss";
import {useHistory} from "react-router-dom";
import { PlayCircleOutlined } from '@ant-design/icons';
import "./VideoDesktop.scss";



function VideoDesktop({item}) {
    const history = useHistory();


    return(
        <div className="video-desktop-container">

            <div className="video-desktop-list">

                {item.items.map(i=>{
                    return(
                        <div onClick={()=>{
                            window.open(i.link_to_uid, "_blank") //t
                        }} className="video-desktop-container-item" style={{backgroundImage: `url(${i.image})`}}>
                            <PlayCircleOutlined  style={{fontSize:40,color:"#ffffff",zIndex:2}}/>
                            <p>{i.title}</p>
                            <div className="video-desktop-container-item-cover"></div>
                        </div>
                    )
                })}








            </div>

        </div>

    )
}

export {VideoDesktop};
